<script setup>
import {onMounted, ref, watch} from 'vue';
import BetCalcDecimalInput from "@/components/bet_calc/BetCalcDecimalInput.vue";
import BetCalcFractionalInput from "@/components/bet_calc/BetCalcFractionalInput.vue";
import BetCalcAmericanInput from "@/components/bet_calc/BetCalcAmericanInput.vue";
import {
  decimalToFractional,
  fractionalToDecimal,
  decimalToAmerican,
  americanToDecimal
} from '@/services/oddsConverterServiceFunctions';

const props = defineProps({
  oddsType: String,
  label: String,
  initialNumerator: {
    type: [String, Number],
    required: false
  },
  initialDenominator: {
    type: [String, Number],
    required: false
  },
  initialDecimalOdds: {
     type: String,
    default: '2',
  }

});

const emits = defineEmits(['update:decimalOdds']);

const decimalOdds = ref(props.initialDecimalOdds);
const numerator = ref(props.initialNumerator ? props.initialNumerator: 1);
const denominator = ref(props.initialDenominator ? props.initialDenominator: 1);
const americanOdds = ref('100');

const convertOddsToDecimal = () => {
  if (props.oddsType === 'decimal' && decimalOdds.value) {
    return parseFloat(decimalOdds.value);
  } else if (props.oddsType === 'american') {
    return americanToDecimal(parseFloat(americanOdds.value));
  } else if (props.oddsType === 'fractional') {
    return fractionalToDecimal(`${numerator.value}/${denominator.value}`);
  }
  return null;
};

const updateOdds = (source) => {
  let decimal = parseFloat(convertOddsToDecimal().toFixed(4)).toString();
  emits('update:decimalOdds', decimal);
  if (source !== 'decimal' && decimal) {
    decimalOdds.value = decimal;
  }
  if (source !== 'fractional' && decimal) {
    const [num, den] = decimalToFractional(decimal).split('/').map(Number);
    numerator.value = num;
    denominator.value = den;
  }
  if (source !== 'american' && decimal) {
    const americanValue = decimalToAmerican(decimal);
    americanOdds.value = americanValue.toString();
  }
};


const updateValidatedDecimalOdds = () => {
  if (decimalOdds.value <= 1) decimalOdds.value = '1.0001';
  updateOdds('decimal');
};

onMounted(() => {
  // Run updateOdds on mounted with the initial odds type
  if (decimalOdds.value) {updateOdds(props.oddsType)}
});

watch([decimalOdds, numerator, denominator, americanOdds], () => {
  updateOdds(props.oddsType);
});

watch(() => props.oddsType, (newOddsType) => {
  updateOdds(newOddsType);
});
</script>


<template>
  <div>
    <div v-if="oddsType === 'decimal'">
      <BetCalcDecimalInput
          v-model="decimalOdds"
          :label="label"
          @update:modelValue="updateValidatedDecimalOdds"/>
    </div>
    <div v-if="oddsType === 'fractional'">
      <BetCalcFractionalInput
          :numerator="numerator"
          :denominator="denominator"
          :label="label"
          @update:numerator="value => numerator = value"
          @update:denominator=" value => denominator = value"/>
    </div>
    <div v-if="oddsType === 'american'">
      <BetCalcAmericanInput v-model="americanOdds"
                            :label="label"
                            @update:modelValue="updateOdds('american')"/>
    </div>
  </div>
</template>


<style scoped>
/* Add your styles here */
</style>
